import OnboardingAuthView from './OnboardingAuthView';

export default OnboardingAuthView;
